































































import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

import {
  ConfirmLeaveModal,
  NetworkErrorEmptyState,
  QrCodeForm,
  QrCodeImage,
  ShareQrCodeModal,
  VsLoading
} from '@/components'

import { MobileLayout } from '@/layouts/components'

import {
  ActionButton,
  AsyncState,
  ModalState,
  QrCode,
  QrCodeResourcePayload
} from '@/models'

@Component({
  components: {
    ConfirmLeaveModal,
    MobileLayout,
    NetworkErrorEmptyState,
    QrCodeForm,
    QrCodeImage,
    ShareQrCodeModal,
    VsLoading
  }
})
export default class QrCodeDetails extends Vue {
  @Prop({ type: Number, required: true })
  readonly qrCodeId!: number

  loadState = new AsyncState()
  updateState = new AsyncState()
  shareQrCodeState = new ModalState()
  confirmLeaveState = new ModalState()

  data: QrCodeResourcePayload | null = null
  isValid = false

  qrCodeUrl = ''

  get buttons (): ActionButton[] {
    if (this.qrCode === null) {
      return []
    }

    return [
      {
        icon: 'share',
        color: 'dark',
        handler: () => { this.shareQrCodeState.isActive = true }
      },
      {
        text: 'Salvar',
        handler: this.handleSubmit,
        isDisabled: !this.hasChanges || !this.isValid || this.updateState.isPending
      }
    ]
  }

  get hasChanges () {
    const data = this.data
    const qrCode = this.qrCode

    return data !== null && qrCode !== null && (
      data.locationName !== qrCode.location ||
      data.prepay !== qrCode.isPrepaid ||
      data.active !== qrCode.isActive
    )
  }

  get qrCode (): QrCode | null {
    return this.qrCodeById(this.qrCodeId)
  }

  @Ref()
  readonly qrCodeImage?: QrCodeImage

  @Getter('qrCodes/qrCodeById')
  readonly qrCodeById!: (id: number) => QrCode | null

  @Action('qrCodes/loadQrCode')
  loadQrCode!: (id: number) => Promise<void>

  @Action('qrCodes/updateQrCode')
  updateQrCode!: (data: { id: number; payload: QrCodeResourcePayload }) => Promise<void>

  async created () {
    if (this.qrCode === null) {
      await this.reload()
    } else {
      this.loadState.touch()
    }

    if (this.qrCode) {
      this.data = {
        shopId: this.qrCode.businessUnitId,
        locationName: this.qrCode.location,
        prepay: this.qrCode.isPrepaid,
        active: this.qrCode.isActive
      }
    }
  }

  async reload () {
    try {
      await this.loadState.handle(
        this.loadQrCode(this.qrCodeId)
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleSubmit () {
    if (this.data === null || !this.hasChanges || !this.isValid) {
      return
    }

    try {
      await this.updateState.handle(
        this.updateQrCode({
          id: this.qrCodeId,
          payload: this.data
        })
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  handleGoBack () {
    if (this.hasChanges) {
      this.confirmLeaveState.isActive = true
    } else {
      this.$router.back()
    }
  }
}
